export class Wizard {
    stepName: any;
    stepNum: number;
    stepDesc: any;
    stepClass: any;
    isStepMandatory: boolean;
    iconClass: any;
    iconTooltip: any;
    iconPlacement: any;
    progressbarType: any;
    progressbarMessage: any;
    progressbarValue: number;
    progressbarMessageArray: KeyValueArray[];
    stepDescMessageArray: KeyValueArray[];
    stepDescMessage: any;
    stepExtraMessageArray: any;
    stepExtraMessage: any;
    functionId: number;
    alertPanelType: number;
    highlightStep: any;
    isDisabled: boolean;
    isInfoIcon: boolean;
    infoIconMsg: any;
    stepUrl: any;
    disabledClass:any;
    isProgressBar:any;
    comingSoonDesc:any;
    actualStepNum?: number;
    showButton?:boolean;
    status: any;
    videoUrl: any;
    isActive: boolean;
    focusVisible?: any;
    stats?: WizardStat[];
    stats_two?: WizardStatTwo[];
    stats_three?: WizardStatThree[];
}
export class WizardResponse {
    wizardList: Wizard[];
    cancelledFuncListDetails: any[];
    purchasedFunctionList: any[];
    mileageValidationDate:number;
    isAccountingIntegrationTurnOn: boolean;
    isAllStepCompleted: boolean;
    defaultScrollId: number;
}
export class KeyValueArray {
    key: number;
    value: string
}

export class wizardRequestConfig {
    companyId: number;
    accountingSystemId: number;
}

export class WizardDetailRequest extends wizardRequestConfig {
    WizardAction: number;
    OtherId: number;
   
}
export class wizardConfig {
    mainScrollConditionRequired: boolean;
    defaultScrollId: number;
}

export interface WizardStat {
  label?: string;
  value?: number | string;
  type?: 'active' | 'pending' | 'not-invited'; // Three stat types
}

export interface WizardStatTwo {
  label?: string;
  value?: number | string;
  // No type required for this stat
}

export interface WizardStatThree {
  label?: string;
  value?: number | string;
  // No type required for this stat
}